var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeams(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.0608 25.5352H57.5257C58.8923 25.5352 60.0002 26.643 60.0002 28.0096V41.1852C60.0002 46.2078 55.9286 50.2794 50.906 50.2794H50.863C45.8405 50.2801 41.7683 46.2091 41.7676 41.1865V26.8284C41.7676 26.1141 42.3466 25.5352 43.0608 25.5352Z",
    fill: "#5059C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.837 22.9299C56.0737 22.9299 58.6975 20.3061 58.6975 17.0695C58.6975 13.8328 56.0737 11.209 52.837 11.209C49.6004 11.209 46.9766 13.8328 46.9766 17.0695C46.9766 20.3061 49.6004 22.9299 52.837 22.9299Z",
    fill: "#5059C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6048 22.9303C39.2799 22.9303 43.0699 19.1403 43.0699 14.4651C43.0699 9.78997 39.2799 6 34.6048 6C29.9296 6 26.1396 9.78997 26.1396 14.4651C26.1396 19.1403 29.9296 22.9303 34.6048 22.9303Z",
    fill: "#7B83EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8921 25.5352H22.0152C20.6649 25.5686 19.5967 26.6892 19.6281 28.0395V43.0671C19.4395 51.1705 25.8505 57.895 33.9537 58.0933C42.0568 57.895 48.4678 51.1705 48.2793 43.0671V28.0395C48.3106 26.6892 47.2424 25.5686 45.8921 25.5352Z",
    fill: "#7B83EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.2556 25.5352V46.5938C35.2491 47.5595 34.6639 48.427 33.7709 48.7947C33.4866 48.915 33.181 48.977 32.8723 48.977H20.7737C20.6044 48.5473 20.4481 48.1175 20.3179 47.6747C19.862 46.1804 19.6294 44.6268 19.6276 43.0645V28.0356C19.5963 26.6874 20.6627 25.5686 22.0109 25.5352H35.2556Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M33.9533 25.5352V47.8961C33.9532 48.2048 33.8912 48.5104 33.7709 48.7947C33.4032 49.6877 32.5357 50.2729 31.57 50.2794H21.3858C21.1644 49.8496 20.956 49.4198 20.7737 48.977C20.5914 48.5343 20.4481 48.1175 20.3179 47.6747C19.862 46.1804 19.6294 44.6268 19.6276 43.0645V28.0356C19.5963 26.6874 20.6627 25.5686 22.0109 25.5352H33.9533Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M33.9532 25.5352V45.2915C33.9433 46.6036 32.8821 47.6648 31.57 47.6747H20.3179C19.862 46.1804 19.6294 44.6268 19.6276 43.0645V28.0356C19.5963 26.6874 20.6627 25.5686 22.0109 25.5352H33.9532Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32.6509 25.5352V45.2915C32.641 46.6036 31.5797 47.6648 30.2676 47.6747H20.3179C19.862 46.1804 19.6294 44.6268 19.6276 43.0645V28.0356C19.5963 26.6874 20.6627 25.5686 22.0109 25.5352H32.6509Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.2559 18.8012V22.9035C35.0345 22.9165 34.8261 22.9296 34.6047 22.9296C34.3833 22.9296 34.175 22.9166 33.9536 22.9035C33.514 22.8744 33.078 22.8046 32.6512 22.6952C30.014 22.0706 27.8353 20.2211 26.7908 17.7203C26.6111 17.3003 26.4715 16.8643 26.374 16.418H32.8726C34.1868 16.4229 35.2509 17.487 35.2559 18.8012Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M33.9538 20.1039V22.9039C33.5142 22.8748 33.0782 22.805 32.6515 22.6956C30.0143 22.071 27.8355 20.2215 26.791 17.7207H31.5705C32.8847 17.7257 33.9488 18.7898 33.9538 20.1039Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M33.9538 20.1039V22.9039C33.5142 22.8748 33.0782 22.805 32.6515 22.6956C30.0143 22.071 27.8355 20.2215 26.791 17.7207H31.5705C32.8847 17.7257 33.9488 18.7898 33.9538 20.1039Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32.6515 20.104V22.6956C30.0143 22.071 27.8355 20.2215 26.791 17.7207H30.2682C31.5824 17.7257 32.6465 18.7898 32.6515 20.104Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38715 17.7207H30.264C31.5824 17.7207 32.6511 18.7895 32.6511 20.1079V43.9847C32.6511 45.3031 31.5824 46.3719 30.264 46.3719H6.38715C5.06875 46.3719 4 45.3031 4 43.9847V20.1079C4 18.7895 5.06878 17.7207 6.38715 17.7207Z",
    fill: "url(#paint0_linear_4485_36338)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6078 26.8084H19.8348V39.8056H16.7939V26.8084H12.043V24.2871H24.6078V26.8084Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4485_36338",
    x1: 8.97729,
    y1: 15.8554,
    x2: 27.6739,
    y2: 48.2372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A62C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4D55BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3940AB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams);
export default __webpack_public_path__ + "static/media/teams.83d96277554d97dd63d0af3a39f2a0d0.svg";
export { ForwardRef as ReactComponent };